export function getActiveEnvironmentUrl() {
  // Check if running in Electron
  const isElectron =
    typeof window !== "undefined" && (window as any).electronAPI?.isElectron === true;
  const BASE_CONFIG_URL = "https://assets.marketingassistant.com/configs";
  if (isElectron) {
    const mode = import.meta.env.MODE;
    const electronEnvMap: Record<string, string> = {
      production: "env.production.json",
      staging: "env.staging.json",
      development: "env.staging.json",
    };
    const fileName = electronEnvMap[mode];
    return `${BASE_CONFIG_URL}/${fileName}`;
  }

  // Original browser logic
  const hostName = window.location.hostname;

  const envMap: Record<string, string> = {
    localhost: "env.staging-gifty.json",
    "d25xpy4wjfyth6.cloudfront.net": "env.marketing-tests.json",
    "dbdli8bn2i0o3.cloudfront.net": "env.staging-gifty.json",
    "staging.marketingassistant.com": "env.staging.json",
    "staging-app.marketingassistant.com": "env.staging.json",
    "app.marketingassistant.com": "env.production.json",
    "marketingassistant.com": "env.production.json",
    "d112oo1k3k16of.cloudfront.net": "env.staging-gordon.json",
  };

  const fileName = envMap[hostName];
  if (!fileName) throw new Error("Unknown environment");
  const url = `${BASE_CONFIG_URL}/${fileName}`;
  return url;
}

export async function fetchEnvVariables() {
  const url = getActiveEnvironmentUrl();
  const res = await fetch(url);
  const data: Record<string, string> = await res.json();
  return data;
}

export function setEnvVariables(object: Record<string, string>) {
  const keys = Object.keys(object);
  for (const key of keys) {
    const value = object[key] ?? ""; //allow 0
    env[key] = `${value}`;
  }
}
